var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"c-dashboard__message",attrs:{"role":"alert"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n  "),_c('button',{staticClass:"c-dashboard__message__close",attrs:{"aria-label":"close"},on:{"click":_vm.hideMessage}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9bc23ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/wbwb/wbwb-dashboard-alert.vue
// module id = 607
// module chunks = 0 1